import styled, { css } from 'styled-components'
import { theme } from 'utils/theme'
import logoImage from 'assets/svg/logo.svg'
import gcadLogoImage from 'assets/svg/logoGCAD.svg'
import { BRAND } from 'constants/appConstants'

export const MasterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${({ theme: { brand } }) =>
    brand === BRAND.ATH
      ? css`
          height: 100vh;
          background-image: url(${logoImage});
          background-repeat: no-repeat;
          background-position: 94% 92%;
        `
      : css`
          height: calc(100vh - 140px);
          background: none;
        `}
`

export const TouchToControlContainer = styled.div`
  letter-spacing: 0.16em;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${({ theme: { brand } }) =>
    brand === BRAND.ATH
      ? css`
          font-family: Bison;
          font-weight: 600;
          border: 10px solid ${theme.colors.white};
          height: 524px;
          width: 524px;

          span {
            font-size: 48px;
            line-height: 75px;
            text-transform: uppercase;
          }
        `
      : css`
          font-family: 'Futura Std';
          font-weight: 700;
          border: 3px dashed ${theme.colors.gcadOrange};
          height: 386px;
          width: 386px;

          span {
            font-size: 47px;
            line-height: 73px;
            max-width: 300px;
            text-align: center;
          }
        `}

  span {
    color: ${theme.colors.white};
  }
`

export const Footer = styled.div`
  ${({ theme: { brand } }) =>
    brand === BRAND.ATH
      ? css`
          display: none;
        `
      : css`
          position: absolute;
          bottom: 0;
          left: 0;
          height: 140px;
          width: 100vw;
          background-color: ${theme.colors.white};
          background-image: url(${gcadLogoImage});
          background-repeat: no-repeat;
          background-position: right 60px center;
          background-size: auto 72px;
        `}
`
